import axios from "axios";

const API = axios.create({
  baseURL: "https://api.mobiezy.in/mobi/",
  headers: {
    "Content-Type": "application/json",
  },
});


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loginAPI(value) {
    return API.post("cableguy2_mobile_user_login_new", value);
  },

  collectbill(value) {
    return API.post("cableguy_appUpSyncModified", value);
  },

  COLLECT_SMS1(value) {
    return API.post("crmsmscollectbillandrenew", value);
  },
  agentSummaryAPI(value) {
    return API.post("getAgentSummary", value);
  },
  cashfreepaymentlink(value) {
    return API.post("onclickgeneratecashfreelink", value);
  },
  monthlyReportAPI(value) {
    return API.post("mobileCollectionReport", value);
  },

  dailyReportAPI(value) {
    return API.post("mobileCollectionReport", value);
  },
  OwnerMonthlyReportAPI(value) {
    return API.post("filter_mobileCollectionReport", value);
  },

  agentAreaSummaryAPI(value) {
    return API.post("mobile-agentareasummary", value);
  },

  stbListingAPI(value) {
    return API.post("cableguy2-get-stb-details-test", value);
  },

  subscriptionExpiryReportAPI(value) {
    return API.post("cableguy2-mobile-expiry-report", value);
  },

  subscriptionExpiryReportCountAPI(value) {
    return API.post("cableguy2-mobile-cust-report-based-on-stb", value);
  },
  getcustomerbillhistory(value) {
    return API.post("getCustomerBillHistory", value);
  },
  dropdownAgentDataAPI(value) {
    return API.post("cableguy2_getAreaAndAgentList", value);
  },

  viewCompalintAPI(value) {
    return API.post("getmobileassignedcomplaints", value);
  },

  customerSummary(value) {
    return API.post("mobile-agent-op-summary", value);
  },

  allCustomerData(value) {
    return API.post("down_sync_offline", value);
  },

  recordVisit(value) {
    return API.post("cableguy2_barcode", value);
  },
  lastPaymentHistory(value) {
    return API.post("getmobilelastbill", value);
  },
  STBHistory(value) {
    return API.post("get_customer_stb_details", value);
  },
  getCustomerInfo(value) {
    return API.post("cableguy2-mobile-data-fetch-test", value);
  },
  editCustomerInfo(value) {
    return API.post("mobile-edit-customer-info", value);
  },
  updateCustomerlocation(value) {
    return API.post("update_customer_longlat", value);
  },
  editSTBInfo(value) {
    return API.post("mobileeditstbinfo_new", value);
  },
  addComplaint(value) {
    return API.post("manageComplaints", value);
  },
  activePacks(value) {
    return API.post("cableguy2-get-active-packs-test", value);
  },
  allPacks(value) {
    return API.post("cableguy2_mobile_All_Packs", value);
  },
  ADDallPacks(value) {
    return API.post("mobile_add_channel_all_pack", value);
  },
  modifyPacks(value) {
    return API.post("cableguy2_mobile_modify_packs_test", value);
  },
  addChanel(value) {
    return API.post("mobile-add-channel", value);
  },
  updateComplaint(value) {
    return API.post("updateCompStatus", value);
  },
  fetchPackages(value) {
    return API.post("cableguy2_mobile_All_Packs", value);
  },
  fetchArea(value) {
    return API.post("cableguy2_getAreaAndAgentList", value);
  },
  createCustomer(value) {
    return API.post("managecustomer-prcnew",value);
  }
};
